import { render, staticRenderFns } from "./yjhj.vue?vue&type=template&id=44f1ba46&"
import script from "./yjhj.vue?vue&type=script&lang=js&"
export * from "./yjhj.vue?vue&type=script&lang=js&"
import style0 from "./yjhj.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports